module.exports = __webpack_public_path__ + "static/media/program-1.d24af48f.png";